"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../store/store");
var owa_options_core_1 = require("owa-options-core");
var owa_session_store_1 = require("owa-session-store");
var legacy_1 = require("satcheljs/lib/legacy");
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
    userOptions: function () { return owa_session_store_1.getUserConfiguration().UserOptions; },
})(function isMessageListOptionDirty(state) {
    var savedOptions = state.userOptions;
    var showSenderOnTopInListView = owa_options_core_1.getFallbackValueIfNull(state.optionState.showSenderOnTopInListView, savedOptions.ShowSenderOnTopInListView);
    return showSenderOnTopInListView !== savedOptions.ShowSenderOnTopInListView;
});
//# sourceMappingURL=isSenderSubjectOptionDirty.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-sender-subject-option/lib/utils/isSenderSubjectOptionDirty.js
// module id = 5129
// module chunks = 2